/**
 * Mensajes de error del API (incl. envoltorio "Error código 800" con Detail en texto largo).
 * @param {import('axios').AxiosError} error
 * @param {string} [tituloOpcional]
 */
export function formatApiError(error, tituloOpcional) {
  const d = error?.response?.data;
  if (typeof d === 'string') {
    return [tituloOpcional, d].filter(Boolean).join('\n\n');
  }
  if (!d || typeof d !== 'object') {
    return [tituloOpcional, error?.message].filter(Boolean).join('\n\n') || 'Error desconocido';
  }

  const msg = d.Message || d.message || '';
  let detail = d.Detail || d.detail || '';

  if (typeof detail === 'string' && detail.length) {
    const inner = detail.match(/--->\s*[^:]+:\s*([^\r\n]+)/);
    if (inner && inner[1]) {
      detail = inner[1].trim();
    } else {
      const oneLine = detail.split('\r\n')[0].split('\n')[0];
      detail = oneLine.length > 400 ? `${oneLine.slice(0, 400)}…` : oneLine;
    }
  }

  const logs =
    Array.isArray(d.DebugLogs) && d.DebugLogs.length ? d.DebugLogs.join('\n') : d.DebugLogs;

  const partes = [tituloOpcional, msg, detail, d.Inner || d.inner, logs].filter(
    (x) => x !== undefined && x !== null && String(x).trim() !== ''
  );

  return partes.length ? partes.join('\n\n') : error?.message || 'Error desconocido';
}
